export default "__VITE_ASSET__CFVFetxi__"